import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const STOREFRONT = ["/toko", "/resto", "/akun", "/login"];

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const code = e?.response?.status;
    const onStorefront = STOREFRONT.some((p) => window.location.pathname.startsWith(p));
    if (code === 401 && !onStorefront) {
      localStorage.removeItem("khf_token");
      delete api.defaults.headers.common.Authorization;
      window.location.replace("/login");
    }
    return Promise.reject(e);
  }
);

export const yen = (n) =>
  "¥" + Math.round(Number(n) || 0).toLocaleString("ja-JP");

export const PAYMENTS = [
  { id: "cash", label: "Tunai", color: "#10B981" },
  { id: "paypay", label: "PayPay", color: "#EF4444" },
  { id: "credit_card", label: "Kartu Kredit", color: "#3B82F6" },
  { id: "japan_post_bank", label: "Japan Post Bank", color: "#059669" },
];

export const paymentLabel = (id) =>
  PAYMENTS.find((p) => p.id === id)?.label || "-";

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "Data tidak valid").join(", ");
  return fallback;
};
